class DeviceList {
    serialNumber;
    modelName;
    deviceName;
    name;
    phoneNumber;
    status;
    id;

    constructor(serialNumber, modelName, deviceName, name, phoneNumber, status, id) {
        this.serialNumber = serialNumber;
        this.modelName = modelName;
        this.deviceName = deviceName;
        this.name = name;
        this.phoneNumber = phoneNumber;
        this.status = status;
        this.id = id;
    }

    getId() {
        return this.id;
    }
}

class DeviveLog {
    date;
    text;

    constructor(a, b) {
        this.date = a;
        this.text = b;
    }
}

class DeviceDetail {
    id;
    Modelname;
    SerialNumber;
    ProductionDate;
    brokerPass;
    DeteFirstConnection;
    lastStatus;
    name;
    phoneNumber;
    city;
    grantiNumber;
    grantiDeadTime;
    grantiUsedStatus;
    puchaseDate;
    ActivatingUser;
    activationDate;
    guestid;
    guestname;
    guestNumber;

    constructor(
        guestid,
        guestname,
        guestNumber
    ) {

        this.guestid = guestid;
        this.guestname = guestname;
        this.guestNumber = guestNumber;

    }

    getId() {
        return this.id;
    }
}

export {DeviveLog};
export {DeviceList};
export {DeviceDetail};